import type { RfqApiErrorBody } from "../types";

interface ErrorLike {
  response?: { data?: Record<string, unknown> | string };
  message?: unknown;
}

export function apiErrorMessage(error: unknown, fallback: string): string {
  if (!error || typeof error !== "object") return fallback;
  const { response, message } = error as ErrorLike;
  const data = response?.data;
  if (data && typeof data === "object") {
    if (typeof data.error === "string" && data.error) return data.error;
    if (typeof data.message === "string" && data.message) return data.message;
  }
  if (typeof message === "string" && message) return message;
  return fallback;
}

export function rfqApiError(error: unknown): RfqApiErrorBody | null {
  if (!error || typeof error !== "object") return null;
  const data = (error as ErrorLike).response?.data;
  if (!data || typeof data !== "object") return null;
  return typeof data.error_code === "string" ? (data as unknown as RfqApiErrorBody) : null;
}

const LOAD_ERROR_COPY: Record<string, string> = {
  FEATURE_DISABLED: "RFQs are switched off right now. Please try again later.",
};

export function rfqLoadErrorMessage(error: unknown, fallback: string): string {
  return LOAD_ERROR_COPY[rfqApiError(error)?.error_code ?? ""] ?? fallback;
}

const ACTION_ERROR_COPY: Record<string, string> = {
  VERSION_CONFLICT: "This RFQ changed since you loaded it. We refreshed it, please check and try again.",
};

export function actionErrorMessage(error: unknown, fallback: string): string {
  return ACTION_ERROR_COPY[rfqApiError(error)?.error_code ?? ""] ?? apiErrorMessage(error, fallback);
}
